import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TemplateMetrics = ({ user, templateCount }) => {
  const navigate = useNavigate();

  const email = user?.email;

  return (
    <div className="mb-6 md:mb-8">
      <div className="bg-card border border-border rounded-xl p-6 md:p-8 shadow-elevation-sm">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between lg:gap-8 mb-8">
          <div className="min-w-0 flex-1">
            <h1 className="text-xl md:text-2xl font-bold text-foreground tracking-tight">
              Meus Modelos
            </h1>

            <p className="text-sm text-muted-foreground mt-1 max-w-xl">
              Gerencie seus modelos personalizados para agilizar a criação de documentos.
            </p>

            {email ? (
              <p className="text-xs text-muted-foreground mt-2">
                Conta: {email}
              </p>
            ) : null}
          </div>

          <div className="flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:justify-end lg:w-auto lg:max-w-md lg:shrink-0">
            <Button
              type="button"
              size="lg"
              iconName="LayoutTemplate"
              className="w-full shadow-md sm:min-w-[220px] sm:w-auto"
              onClick={() => navigate('/create-template')}
            >
              Criar Modelo
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
          <div className="rounded-xl border border-border bg-muted/30 p-4 flex gap-3 lg:bg-card">
            <div className="mt-0.5">
              <Icon name="LayoutTemplate" size={18} className="text-muted-foreground" />
            </div>

            <div>
              <p className="text-xs font-medium text-muted-foreground mb-1">
                Total de modelos
              </p>

              <p className="text-sm font-semibold text-foreground">
                {templateCount}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateMetrics;
